import React, { useCallback, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import jwt from "jwt-decode";
import { LoadingIcon } from '.';
import { eAlertsCoreAPIEndpoint, ENDPOINTS } from '../../api';

export default function AuthLoading() {
  let history = useHistory();

  const createNewSubscription = useCallback(async () => {
    let retry = true;
    const token = jwt(localStorage.getItem('token'));
    const accountId = token.id;
    const parcelNumber = localStorage.getItem('parcelNumber');
    const newSubscription = {
      parcelNumber: `${parcelNumber}`,
      isActive: true,
      accountId: `${accountId}`,
      alertTypeId: process.env.REACT_APP_ALERT_TYPE_ALL_ALERTS,
    };
    await eAlertsCoreAPIEndpoint(ENDPOINTS.SUBSCRIPTION)
      .create(newSubscription)
      .then((Response) => {
        if (Response.status === 200) {
          history.push(`/dashboard/${accountId}`);
        } else {
          history.push(`/login?parcelNumber=${parcelNumber}`);
        }
      })
      .catch(() => {
        if (retry) {
          retry = false;
          window.location.reload();
        } else {
          history.push(`/login?parcelNumber=${parcelNumber}`);
        }
      });
  }, [history]);

  useEffect(() => {
    const token = jwt(localStorage.getItem('token'));
    const accountId = token.id;
    const parcelNumber = localStorage.getItem('parcelNumber');
    if (parcelNumber && parcelNumber !== '') {
      createNewSubscription();
    } else {
      history.push(`/dashboard/${accountId}`);
    }
  }, [createNewSubscription, history]);

  return (
    <>
      <Helmet>
        <title>Loading...{process.env.REACT_APP_PAGETITLE_TEXT}</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <LoadingIcon loadingText="Your Account is Loading" />
    </>
  );
}
